import React from 'react'
import styled from '@emotion/styled'
import Ajanlatkeres from '../containers/Ajanlatkeres'
import i00001 from '../images/tetok-badogos/00001.jpg'
import i00002 from '../images/tetok-badogos/00002.jpg'
import i00003 from '../images/tetok-badogos/00003.jpg'
import i00004 from '../images/tetok-badogos/00004.jpg'
import i00005 from '../images/tetok-badogos/00005.jpg'
import i00006 from '../images/tetok-badogos/00006.jpg'
import i00007 from '../images/tetok-badogos/00007.jpg'
import i00008 from '../images/tetok-badogos/00008.jpg'
import i00009 from '../images/tetok-badogos/00009.jpg'
import i00010 from '../images/tetok-badogos/00010.jpg'
import i00011 from '../images/tetok-badogos/00011.jpg'
import i00012 from '../images/tetok-badogos/00012.jpg'
import i00013 from '../images/tetok-badogos/00013.jpg'
import i00014 from '../images/tetok-badogos/00014.jpg'
import i00015 from '../images/tetok-badogos/00015.jpg'
import i00016 from '../images/tetok-badogos/00016.jpg'
import i00017 from '../images/tetok-badogos/00017.jpg'
import i00018 from '../images/tetok-badogos/00018.jpg'
import i00019 from '../images/tetok-badogos/00019.jpg'
import i00020 from '../images/tetok-badogos/00020.jpg'
import i00021 from '../images/tetok-badogos/00021.jpg'
import i00022 from '../images/tetok-badogos/00022.jpg'
import i00023 from '../images/tetok-badogos/00023.jpg'
import i00024 from '../images/tetok-badogos/00024.jpg'
import i00025 from '../images/tetok-badogos/00025.jpg'
import i00026 from '../images/tetok-badogos/00026.jpg'
import i00027 from '../images/tetok-badogos/00027.jpg'
import i00028 from '../images/tetok-badogos/00028.jpg'
import i00029 from '../images/tetok-badogos/00029.jpg'
import i00030 from '../images/tetok-badogos/00030.jpg'
import i00031 from '../images/tetok-badogos/00031.jpg'
import i00090 from '../images/tetok-badogos/00090.jpg'
import i00091 from '../images/tetok-badogos/00091.jpg'
import i00092 from '../images/tetok-badogos/00092.jpg'
import i00093 from '../images/tetok-badogos/00093.jpg'
import i00094 from '../images/tetok-badogos/00094.jpg'
import i00095 from '../images/tetok-badogos/00095.jpg'
import i00096 from '../images/tetok-badogos/00096.jpg'
import i00097 from '../images/tetok-badogos/00097.jpg'
import i00098 from '../images/tetok-badogos/00098.jpg'

const Main = styled.main`
  margin-top: 70px;
  line-height: 1.5rem;
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2.5rem;
  }
`

const SubTitle = styled.h3`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2rem;
  }
`

const Section = styled.section`
  position: relative;
  padding: 0 1rem;
  padding-bottom: 8px;
  margin: 2rem 0;

  a {
    text-decoration: none;
    color: initial;
  }

  ul {
    list-style: circle;

    li {
      margin: 0.5rem 0;

      a:after {
        content: ' ›';
      }
    }
  }

  &:first-of-type {
    margin-bottom: 4rem;
  }

  &:nth-of-type(2n) {
    background: linear-gradient(transparent 80px, rgba(39, 82, 54, 0.2) 80px, rgba(39, 82, 54, 0.2) 100%);

    ${SubTitle} {
      // color: #fff;
    }

    &:before {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      top: calc(80px - 2rem);
      width: 100%;
      height: 2rem;
      background: linear-gradient(to right top, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }

    &:after {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      bottom: -2rem;
      width: 100%;
      height: 2rem;
      background: linear-gradient(to left bottom, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }
  }

  @media (min-width: 64em) {
    p,
    ul,
    ${Title}, ${SubTitle} {
      margin: 2rem auto;
      max-width: 960px;
    }

    &:nth-of-type(2n) {
      &:before {
        top: calc(80px - 4rem);
        height: 4rem;
      }

      &:after {
        bottom: -4rem;
        height: 4rem;
      }
    }
  }
`

const Images = styled.section`
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  height: 320px;
  margin: 0 -1rem;
  width: calc(100% + 2rem);
  display: flex;
  flex-direction: row;

  img {
    flex: 1;
    display: block;
    height: 100%;
  }

  img + img {
    margin-left: 5px;
  }

  @media (min-width: 64em) {
    overflow-x: auto;
    margin: 0 auto;
    max-width: 1540px;
    height: auto;
    flex-wrap: wrap;

    img {
      flex: 1;
      display: block;
      width: 30%;
      // height: auto;
      margin: 5px;
    }
  }
`

const ScrollIndicator = styled.span`
  text-align: center;
  width: 100%;
  display: block;
  font-size: 0.8rem;
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  color: #fff;

  @media (min-width: 64em) {
    display: none;
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        <Title>Tetőépítés, felújítás, karbantartás, gyorsszolgálat</Title>
        <p>Válasszon az alábbiak közül:</p>
        <ul>
          <li>
            <a href="#tetoepites">Tetőépítés</a>
          </li>
          <li>
            <a href="#beazas">Beázás megszüntetése</a>
          </li>
          <li>
            <a href="#tetojavitas">Tetőjavítás</a>
          </li>
          <li>
            <a href="#karbantartas">Éves tető karbantartás</a>
          </li>
          <li>
            <a href="#kartevok-elleni-vedelem">Kártevők elleni védelem</a>
          </li>
          <li>
            <a href="#ereszcsatorna-tisztitas">Ereszcsatorna tisztítás</a>
          </li>
          <li>
            <a href="#fagydugok-megelozese">Fagydugók megelőzése</a>
          </li>
          <li>
            <a href="#szellozonyilasok-ellenorzese">Szellőzőnyílások ellenőrzése</a>
          </li>
          <li>
            <a href="#latszo-feluletek-kezelese">Látszó fafelületek kezelése</a>
          </li>
          <li>
            <a href="#galamburulek-eltakaritas">Galambürülék eltakarítása</a>
          </li>
          <li>
            <a href="#ereszcsatorna-tisztitas">Ereszcsatorna tisztítás</a>
          </li>
          <li>
            <a href="#cserepeslemez-szereles">Cserepeslemez szerelés</a>
          </li>
          <li>
            <a href="#gyorsszolgalat">Gyorszolgálat</a>
          </li>
          <li>
            <a href="#kepek">Képek</a>
          </li>
        </ul>
      </Section>
      <Section>
        <SubTitle id="tetoepites">Tetőépítés</SubTitle>
        <p>
          Közintézmények, lakóépületek, családi házak, melléképületek, ipari csarnokok, fedett teraszok, kerti játékok
          egyik legfontosabb szerkezete az időjárástól védő tető. A tető meghatározza az építmény megjelenését, stílusát
          és számos szabványnak, előírásnak, teljesítmény elvárásnak kell megfeleljen. A tető szerkezetét, állékonyságát
          az ácsszerkezet biztosítja, amely ma is jellemzően fából készül, de a fém szerkezetek is teret nyertek. A kész
          ácsszerkezet fóliázás, ellenlécezés és lécezés után megkapja végleges borítását. A tetőfedés anyaga a
          megrendelő igényeihez igazodik, de előfordul, hogy műemlék védettség miatt a fedés nem változtatható! A fedés
          mellett a bádogos munkák is biztosítják a szerkezet időjárás állóságát. A beltéri oldalon szarufák közeit
          kitöltő szigetelés pedig a hőkomfortért az energiafelhasználás optimalizálásáért felelős. Az utóbbi évek egyre
          gyakoribb igénye a tetősík ablakok utólagos beépítése, kéményseprő járdák elhelyezése, napelem, vagy
          napkollektor elhelyezése vagy előkészítése.
        </p>
        <p>Vállaljuk tetők építését, felújítását, szigetelését.</p>
        <ul>
          <li>Tetőszerkezet építés</li>
          <li>Tetőfedés (beton, kerámiacseréppel, zsindelyezés, pala, fémlemezfedés)</li>
          <li>Új tető építés, régi tető felújítás, javítás, karbantartás, gyors szolgálat keretén belül is</li>
          <li>Tetőszigetelés, hőszigetelés</li>
          <li>Tetősík ablakok utólagos behelyezése</li>
          <li>Fafödém elkészítése</li>
          <li>Faanyagvédelmet (rovar, gomba, tűzvédelem)</li>
        </ul>
      </Section>
      <Section>
        <SubTitle id="beazas">Beázás megszüntetése</SubTitle>
        <p>
          Épületek fenntartása, karbantartása során, ne csak a belső térre koncentráljunk! A felújítást, minden esetben
          a tetővel kezdjük a beázások, nagyobb károk elkerülése végett. Abban az esetben, ha a tetőnk sérült, beázik a
          födém és falak is átáztak ez vezethet visszafordíthatatlan állagromláshoz, mely nagyobb javítási költségbe fog
          kerülni. Napjainkban jellemző a szélsőséges időjárási körülmények (Forróság, fagy, heves esőzések, viharok,
          szélviharok). Ezek a körülmények megviselik a fedést, tetőszerkezetet, ezért különösen fontos ellenőriztetni,
          átvizsgáltatni azt szakemberrel!
        </p>
      </Section>
      <Section>
        <SubTitle id="tetojavitas">Tetőjavítás</SubTitle>
        <p>
          A fedés, lécezés, fóliázás, hőszigetelés, tetőszerkezet javítását, megerősítését jelenti. Minden esetben
          azonnali javításra szorulnak a hiányos, törött, repedt cserepek. A viharkárok által okozott sérülések, melyek
          a fedést megrongálták, bádogos szerkezeteken károsodásokat okoztak. Sok esetben a tetők már régiek, elavultak,
          vagy egyszerűen felújításra szorulnak. Ez esetben nem szabad halogatni a döntést! Sok kellemetlenségtől
          kímélhetjük meg magunkat, mivel ez hatással van az épületszerkezet további romlására. Elsődleges probléma a
          hőszigetelés. Amennyiben nem megfelelő a hőszigetelése a tetőnek, úgy nagy energiaveszteséggel számolhatunk,
          tekintve, hogy a hő felfelé száll. A szigetelés mellett a megfelelő alátét és párazáró fólia is fontos. Hőhíd
          ott alakul ki, ahol a különböző anyagú épületszerkezetek találkoznak és nem megfelelő a hőszigetelés, nincs
          átszellőztetett légrés, aminek hiányában nem megoldott a nyári átmelegedés elleni védelem. Bitumenes zsindely
          fedésnél, jellemzően megég a zsindely és felpöndörödik. Kiszellőztetés hiányában probléma az állandó penész
          kialakulása, tetőszerkezet szaruzatán, lakásban. Ha ilyet tapasztal, forduljon azonnal hozzánk!
        </p>
      </Section>
      <Section>
        <SubTitle id="karbantartas">Éves tető karbantartás</SubTitle>
        <p>
          Számos Önkormányzatnak, Tankerületnek, Magánszemélynek, Társasháznak nincs anyagi fedezete a teljes tető
          lecserélésére. Az éves tetőkarbantartás jó megoldást nyújt, hogy előre megegyezett rezsióradíj, kiszállási
          díj, anyagigazgatási díj fejében, folyamatos karbantartást végezhessünk és elkerüljük a nagyobb károk
          bekövetkezését. Karbantartási szerződés keretein belül. Az elszámolás a helyszínen felvett munkalap alapján
          történik. Tető a külső időjárási hatásoknak leginkább kitett épületrész, ahhoz hogy hosszú ideig
          rendeltetésszerűen működjön, és megőrizze eredeti esztétikus megjelenését, rendszeres karbantartás szükséges.
          A karbantartás feladata kettős: a károk megelőzése és a már bekövetkezett kisebb hibák kijavítása. A tető
          meghibásodás, károsodás szempontjából kritikus részletei jellemzően a szegélyek, hajlatok és áttörések mentén
          találhatók.
        </p>
      </Section>
      <Section>
        <SubTitle id="kartevok-elleni-vedelem">Kártevők elleni védelem</SubTitle>
        <p>
          A leghatásosabb védekezés ellenük mindenképpen a megelőzés. A legnagyobb problémákat a madarak (galambok,
          szarkák), rovarok (méhek, darazsak), esetleges rágcsálók (nyest, mókus, egér, patkány) okozzák, melyek
          egészségünkre is veszélyt jelenthetnek.
        </p>
        <p>
          Madarak: Fontos ez esetben is a megelőzés. Szellőző szalagok, madárhálók, zárt kibúvók, ablakok, zárt
          tetőfedés használatával könnyedén távol tudjuk tartani őket. A madarak közül elsősorban a galambok okoznak
          károkat a savas ürülékükkel. Szennyezik a tetőt, homlokzatot a bádogos szerkezeteket, amely gyors
          állagromláshoz és a fémek korrodálódásához vezet. Felhalmozódott ürülékük veszélyes hulladék és fészekanyaguk
          pedig eltömítheti az ereszcsatornát, amelynek következtében ingatlanunk vizesedni kezd. Napjainkban már számos
          galambriasztó rendszert tudunk alkalmazni, amelyek a madár védelme mellett épületünk megóvását is biztosítja.
          Mechanikai, elektromos, biológia, kémiai védelem.
        </p>
        <p>
          Rovarok: Méhek/Darazsak: Szeretik a tetőn lévő lyukakon keresztül a cserép alá jutást, ez lehet a cserép
          elmozdulása vagy rovarszalag hiánya. A folyamatos ázásból adódóan a vizes faszerkezet táptalaja a gombák
          elszaporodását, lágyabb lesz, darazsak befészkelnek. Rovarirtással lehet megszabadulni tőlük és a fedést
          zárttá kell tenni.
        </p>
        <p>
          Rágcsálók: Rendkívül bosszantó hang ( kaparászás ) és szaghatásokkal jár, fizikailag is károsítják
          épületeinket. A tető szigetelésbe költöznek, fialnak, előszeretettel beköltöznek a szellőzőrendszerekbe, vagy
          megrágják a falban futó kábeleket. Védekezés, zárt tetőfedéssel, szigeteléssel, méreggel.
        </p>
      </Section>
      <Section>
        <SubTitle id="ereszcsatorna-tisztitas">Ereszcsatorna tisztítás</SubTitle>
        <p>
          Az ereszcsatorna rendszer a tető leginkább karbantartást igénylő része. Ennek oka az, hogy a vizet gravitációs
          úton vezetjük, nyitott és zárt rendszerben, emiatt könnyen eldugulhat, ez pedig az épület más szerkezeteiben
          is komoly károsodást okozhat (vizesedés, jegesedés okozta károk). Az ereszcsatorna karbantartása a legtöbb
          esetben ellenőrzést és tisztítást jelent. Megelőzésképpen célszerű átvizsgáltatni évi legalább kétszer a
          csapadékelvezető rendszereket, megkeresni, majd megszüntetni azokat a problémákat, melynek következményeként
          kialakulhat a hiba. A hagyományosan fém csatornák esetén idővel gondot okoz a savas eső, a madárürülék, a
          tetőre hulló falevelek, a tetőelemekből kioldódó vegyszerek, melyek hatására a bevonatuk sérül, és teret enged
          a hordozóréteg korróziójának, melynek következtében csöpögés indulhat meg. A csöpögés pedig lassan-lassan
          folyni kezd, és a falszerkezetek állagromlásához vezet. A nagyobb szennyeződéseket kézzel távolítjuk el. A
          faleveleket kis kézi kefével összehúzzuk, eltávolíthatjuk kézzel az ázott leveleket, leülepedett
          szennyeződéseket pedig az erre a célra alkalmas kézi lapáttal. A szennyeződések eltávolítása után átmossuk a
          csatornarendszert. Az átmosással egyúttal a lefolyócsöveket is ellenőrizzük. Dugulás egyik egyértelmű jele, ha
          a víz visszatorlódik és csak lassan folyik le. Görényezéssel, nagynyomású mosóval, bontással megszüntethető.
          Ajánlott lombfogó kosár elhelyezése. A mosás után ellenőrizzük az ereszcsatorna lejtését.
        </p>
      </Section>
      <Section>
        <SubTitle id="fagydugok-megelozese">Fagydugók megelőzése</SubTitle>
        <p>
          Fagydugó akkor alakulhat ki az ereszcsatornában, ha karbantartás hiányában a felgyülemlő szennyeződés,
          falevél, galamb tetetem, megfogja a vizet és az télen megfagy. A jég jelentős károkat okoz: eldeformálja az
          elemeket, nagy súlya miatt pedig akár le is szakíthatja az ereszt. A már kialakult jégtorlaszt csak
          melegítéssel szüntethetjük meg. Lombfogó ráccsal a felgyülemlő szennyeződés távol tartható. Természetesen a
          leghatékonyabb megoldás a jégtorlasz kialakulásának megelőzése, ez ráccsal vagy fűtéssel oldható meg.
        </p>
      </Section>
      <Section>
        <SubTitle id="szellozonyilasok-ellenorzese">Szellőzőnyílások ellenőrzése</SubTitle>
        <p>
          A tetőfedés alatti szellőző levegő áramlásának feltétele, hogy legyen légrés és az eresz mentén a
          szellőzőnyílások szabadok legyenek. Hőszigetelés és egyéb építőanyag maradványok, darázsfészkek, kisebb
          madárfészkek, elhullott rovarok, bogarak zárhatják el a levegő útját. Az alsó sor cserép felszedésével
          tisztítható a szellőző szalaghoz összegyülemlett szennyeződések. Ellenőrizendő a pontszellőzők rácsai is, hogy
          darázsfészek nem zárja e el a szellőző levegő útját.
        </p>
      </Section>
      <Section>
        <SubTitle id="latszo-feluletek-kezelese">Látszó fafelületek kezelése</SubTitle>
        <p>
          A tetőszerkezet külső látszó fafelületeit, szarufavégek, lambériázás, homlok, oromdeszka felületeit,
          felületkezeléssel kell ellátni (lazúrozás, olajfesték). Ez az esztétikus megjelenés mellett biztosítja a
          faszerkezet védelmét a káros hatásokkal szemben (gombák, napsugárzás, rovarok stb.). A felületkezelést 2-3
          évente mindenképpen ajánlott újra megismételni.
        </p>
      </Section>
      <Section>
        <SubTitle id="galamburulek-eltakaritas">Galambürülék eltakarítása</SubTitle>
        <p>
          A galambürülék veszélyes hulladéknak számít, ezért védőfelszerelésben ajánlott eltávolítani. Betegséget
          terjeszthet, mert mikróbákat és élősködőket tartalmaz! Savassága miatt erősen roncsolja a felületet,
          asztmatikus rohamokat, allergiát is kiválthat. A galambürülék takarítás, ezért is veszélyes feladat. Sok
          esetben csak alpin-technikával végezhető el a takarítás. A galambürülék közelében madártetem is lehet, amely
          még nagyobb veszélyforrást jelenthet. A madártetemet szabad kézzel megfogni tilos! A takarítás után
          fertőtlenítjük is az adott helyet, hogy ne kelljen a fertőzésveszélytől félnie. A teraszról, párkányról, az
          épület tetejéről és homlokzatáról, padlásról is eltakarítjuk a galambpiszkot. Amennyiben szükséges a
          fertőtlenítés után tisztasági festést is csinálunk. Miután a tisztítással végeztünk a galamb riasztással,
          védelemmel is elláthatjuk a felületeket.
        </p>
        <p>Galambvédelem/Galambmentesít alpintechnikával.</p>
        <ul>
          <li>Galambvédelem - párkány, csatorna kialakítása tüskés védelemmel</li>
          <li>Egyéb gipszdíszek, stukkók védelme galambtüskével</li>
          <li>Erkélyek, zárt udvarok, világítóudvarok védelme hálóval</li>
          <li>Elektromos galambvédelem kialakítása</li>
        </ul>
      </Section>
      <Section>
        <SubTitle id="ereszcsatorna-tisztitas">Ereszcsatorna tisztítás</SubTitle>
        <p>
          Az ereszcsatorna rendszer a tető leginkább karbantartást igénylő része. Ennek oka az, hogy a vizet gravitációs
          úton vezetjük, nyitott és zárt rendszerben, emiatt könnyen eldugulhat, ez pedig az épület más szerkezeteiben
          is komoly károsodást okozhat (vizesedés, jegesedés okozta károk). Az ereszcsatorna karbantartása a legtöbb
          esetben ellenőrzést és tisztítást jelent. Megelőzésképpen célszerű átvizsgáltatni évi legalább kétszer a
          csapadékelvezető rendszereket, megkeresni, majd megszüntetni azokat a problémákat, melynek következményeként
          kialakulhat a hiba. A hagyományosan fém csatornák esetén idővel gondot okoz a savas eső, a madárürülék, a
          tetőre hulló falevelek, a tetőelemekből kioldódó vegyszerek, melyek hatására a bevonatuk sérül, és teret enged
          a hordozóréteg korróziójának, melynek következtében csöpögés indulhat meg. A csöpögés pedig lassan-lassan
          folyni kezd, és a falszerkezetek állagromlásához vezet. A nagyobb szennyeződéseket kézzel távolítjuk el. A
          faleveleket kis kézi kefével összehúzzuk, eltávolíthatjuk kézzel az ázott leveleket, leülepedett
          szennyeződéseket pedig az erre a célra alkalmas kézi lapáttal. A szennyeződések eltávolítása után átmossuk a
          csatornarendszert. Az átmosással egyúttal a lefolyócsöveket is ellenőrizzük. Dugulás egyik egyértelmű jele, ha
          a víz visszatorlódik és csak lassan folyik le. Görényezéssel, nagynyomású mosóval, bontással megszüntethető.
          Ajánlott lombfogó kosár elhelyezése. A mosás után ellenőrizzük az ereszcsatorna lejtését.
        </p>
      </Section>
      <Section>
        <SubTitle id="cserepeslemez-szereles">Cserepeslemez szerelés</SubTitle>
        <p>
          A cserepeslemez egy modern tetőfedési lehetőség. Gyors felszerelés jellemzi ezt a héjazat fajtát, minden
          esetben az egyéni igényekhez igazodva kerülnek legyártásra az elemek.
        </p>
        <p>A cserepeslemez előnyei:</p>
        <ul>
          <li>Jó minőségű, horganyzott acélból készül, így teherbírása igen nagy. </li>
          <li>Tömegük kicsi, 5 kg/m2, nem terheli a tetőszerkezetet </li>
          <li>
            A lemezek igény szerinti hosszúságban készülnek, így a hulladék minimálisra csökken. A cserepeslemez 1,2
            méter fedési szélességű, maximális hossza pedig 5,5 – 6 méter.
          </li>
          <li>
            A tetszőleges méretben gyártott lemez akár egy darabban szerelhető a tetőlécekre, amivel sok időt és
            energiát spórolhatunk meg.
          </li>
          <li>Akár már 14 fokos hajlásszögű tetőnél is alkalmazható. </li>
          <li>Több fajta felületen használható. </li>
          <li>Széles a színválasztéka, ezáltal esztétikus kiegészítő lehet, könnyen harmonizálhat a homlokzattal. </li>
          <li>A lemezek bevonati rendszerének köszönhetően nem igényel semmilyen karbantartást. </li>
          <li>
            Alkalmazható hozzá páraáteresztő fólia: tökéletes vízzáró, ami elvezeti a felgyülemlett kondenzvizet,
            átereszti a levegőt.
          </li>
        </ul>
      </Section>
      <Section>
        <SubTitle id="gyorsszolgalat">Gyorszolgálat</SubTitle>
        <p>
          Rövid határidővel vállaljuk tetők javítását, beázások azonnali SOS megszüntetését. Előre megegyezett
          rezsióradíj, kiszállási díj, anyagigazgatási díj fejében. Az elszámolás a helyszínen felvett munkalap alapján
          történik. Igény szerint, veszélyes esetben 1 óra, általános esetben 4 óra kiszállással a helyszínen tudunk
          lenni és megkezdeni a hiba elhárítását.
        </p>
      </Section>
      <Section>
        <SubTitle id="kepek">Képek</SubTitle>
        <Images>
          <img src={i00094} alt="" />
          <img src={i00092} alt="" />
          <img src={i00093} alt="" />
          <img src={i00091} alt="" />
          <img src={i00096} alt="" />
          <img src={i00001} alt="" />
          <img src={i00002} alt="" />
          <img src={i00003} alt="" />
          <img src={i00004} alt="" />
          {/* <img src={i00005} alt="" /> */}
          <img src={i00006} alt="" />
          <img src={i00007} alt="" />
          <img src={i00008} alt="" />
          <img src={i00010} alt="" />
          <img src={i00009} alt="" />
          <img src={i00011} alt="" />
          <img src={i00012} alt="" />
          <img src={i00013} alt="" />
          <img src={i00014} alt="" />
          <img src={i00015} alt="" />
          <img src={i00016} alt="" />
          <img src={i00017} alt="" />
          <img src={i00018} alt="" />
          <img src={i00019} alt="" />
          <img src={i00020} alt="" />
          <img src={i00021} alt="" />
          <img src={i00022} alt="" />
          <img src={i00023} alt="" />
          <img src={i00024} alt="" />
          <img src={i00025} alt="" />
          <img src={i00026} alt="" />
          <img src={i00027} alt="" />
          <img src={i00028} alt="" />
          <img src={i00029} alt="" />
          <img src={i00030} alt="" />
          <img src={i00031} alt="" />
        </Images>
        <ScrollIndicator>◀ ● ▶</ScrollIndicator>
      </Section>
      <Ajanlatkeres />
    </Main>
  </div>
)
